// extracted by mini-css-extract-plugin
export default {"container":"Food_container__EF8NS","box-cards":"Food_box-cards__qu3eh","card":"Food_card__1Mqg9","btn":"Food_btn__-oqIf"};